import { Component, Input, OnInit } from "@angular/core";

import { SharedService } from "@shared/services/shared.service";
import { IBusinessSiteVisitViewModel } from "app/models/complaints/siteVisit";
import { IAdministrativeComplaintView } from "app/models/mainMenu/mainMenu";

import { BusinessService } from "app/services/business/business.service";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { SiteVisitService } from "app/services/complaint/siteVisit.service";
import { Subscription } from "rxjs";


@Component({
  selector: 'shared-sharedSiteVisit',
  templateUrl: './sharedSiteVisit.component.html',
  styleUrls: ['./sharedSiteVisit.component.scss']
})

export class SharedSiteVisitComponent implements OnInit {

  @Input() parentPanel: number = 0;

  sharedSubscription: Subscription;
  visitSubscription: Subscription;
  currentTab: number = 0;
  businessId: number = 0;
  complaintId: number = 0;
  businessName: string = '';
  localSite: IBusinessSiteVisitViewModel = {} as IBusinessSiteVisitViewModel;
  complaint: IAdministrativeComplaintView = null;

  constructor(
    private complaintService: ComplaintService,
    private businessService: BusinessService,
    private siteVisitService: SiteVisitService,
    private sharedService: SharedService
  ) {

  }

  ngOnInit(): void {
    this.businessName = '';
    if (this.parentPanel == 0) {
      this.sharedSubscription = this.complaintService.updateEvent.subscribe((data: number) => {
        if (data == 4) {
          this.businessId = this.complaintService.currentComplaint.businessId;
          this.complaintId = this.complaintService.currentComplaint.complaintId;
          this.businessName = this.complaintService.currentComplaint.businessName;
          this.currentTab = this.complaintService.complaintVisitTab;
          this.complaint = this.complaintService.currentComplaint;
          this.siteVisitService.complaintId = this.complaintService.currentComplaint.complaintId;
          this.siteVisitService.getSiteVisitData(this.businessId);
        }
      });
    } else {
      this.sharedSubscription = this.businessService.updateBusinessEvent.subscribe((data: number) => {
        if (data == 3 || data == 0) {
          this.businessId = this.businessService.businessId;
          this.businessName = this.businessService.currentBusiness.businessName;
          this.currentTab = 0;
          this.siteVisitService.complaintId = 0;
          this.siteVisitService.getSiteVisitData(this.businessId);
        }
      });
    }
    this.visitSubscription = this.siteVisitService.updateSiteVistEvent.subscribe((data: number) => {
      this.localSite = this.siteVisitService.siteVisit;
    });
  }

  ngOnDestroy() {
    this.sharedSubscription.unsubscribe();
    this.visitSubscription.unsubscribe();
  }

  init(){
  }

  tab(){
  }

}